<template>
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_7299_834)">
            <path
                d="M18.4399 3.55173C16.4657 1.58494 13.8407 0.5012 11.044 0.5C5.28085 0.5 0.590819 5.16791 0.588512 10.9054C0.58784 12.7394 1.06916 14.5297 1.98403 16.1078L0.500732 21.5L6.0433 20.0531C7.57038 20.8822 9.28978 21.3191 11.0395 21.3198H11.0439H11.044C16.8062 21.3198 21.4969 16.6511 21.4994 10.9139C21.5003 8.13319 20.4137 5.51866 18.4399 3.55173ZM11.044 19.5623H11.0406C9.48099 19.5615 7.95158 19.1446 6.61757 18.3565L6.30009 18.1692L3.01102 19.0277L3.88916 15.8362L3.68231 15.509C2.81235 14.1318 2.35309 12.5403 2.35374 10.9061C2.35565 6.13725 6.25383 2.25758 11.0473 2.25758C13.3685 2.25854 15.5502 3.15935 17.191 4.79409C18.8318 6.42881 19.7347 8.60195 19.734 10.9131C19.732 15.6821 15.8336 19.5623 11.044 19.5623Z"
                fill="#E0E0E0"
            />
            <path
                d="M0.980713 20.9017L2.39625 15.7558C1.52295 14.2498 1.06371 12.5412 1.06426 10.7913C1.06655 5.31595 5.54238 0.861404 11.0418 0.861404C13.7109 0.862604 16.216 1.89679 18.0996 3.77378C19.9835 5.65076 21.0204 8.14569 21.0193 10.799C21.017 16.2745 16.5409 20.7294 11.0422 20.7294C11.0418 20.7294 11.0425 20.7294 11.0422 20.7294H11.0377C9.36795 20.7289 7.72722 20.3116 6.27 19.5209L0.980713 20.9017Z"
                fill="url(#paint0_linear_7299_834)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.46032 6.48782C8.26689 6.05965 8.06323 6.05108 7.8792 6.04359C7.72868 6.03716 7.55636 6.03756 7.38431 6.03756C7.21213 6.03756 6.93233 6.10198 6.69571 6.35926C6.45896 6.61653 5.79175 7.23848 5.79175 8.50342C5.79175 9.7685 6.71724 10.9909 6.84624 11.1625C6.97537 11.334 8.63278 14.0128 11.2576 15.0433C13.4391 15.8998 13.883 15.7294 14.3566 15.6866C14.8301 15.6437 15.8844 15.0648 16.0996 14.4644C16.3149 13.8641 16.3149 13.3496 16.2503 13.242C16.1857 13.1349 16.0136 13.0706 15.7553 12.942C15.497 12.8134 14.2274 12.1914 13.9907 12.1056C13.7539 12.0199 13.5817 11.9771 13.4095 12.2345C13.2374 12.4916 12.7427 13.0706 12.5921 13.242C12.4414 13.4138 12.2907 13.4353 12.0325 13.3067C11.7742 13.1777 10.9425 12.9065 9.95578 12.0306C9.18808 11.3492 8.66977 10.5076 8.51911 10.2502C8.36845 9.99306 8.50296 9.85378 8.63251 9.72561C8.74846 9.61042 8.89078 9.42547 9.01992 9.27534C9.14878 9.1252 9.19183 9.01806 9.27792 8.84663C9.36401 8.67493 9.32097 8.52482 9.2564 8.39625C9.19183 8.26768 8.68995 6.99621 8.46032 6.48782Z"
                fill="white"
            />
            <path
                d="M18.3543 3.51866C16.4028 1.57445 13.808 0.50317 11.0433 0.501953C5.34634 0.501953 0.710147 5.11627 0.707857 10.7879C0.707186 12.6009 1.18298 14.3706 2.08734 15.9306L0.621094 21.2609L6.10004 19.8305C7.60961 20.6502 9.30925 21.0821 11.0389 21.0827H11.0433H11.0433C16.7394 21.0827 21.3762 16.4676 21.3787 10.7962C21.3796 8.04752 20.3055 5.46301 18.3543 3.51866ZM11.0433 19.3455H11.04C9.49826 19.3447 7.9864 18.9326 6.66771 18.1535L6.35387 17.9683L3.10256 18.817L3.97061 15.6621L3.76614 15.3386C2.90616 13.9773 2.45217 12.404 2.45284 10.7886C2.45472 6.07453 6.30814 2.23939 11.0466 2.23939C13.3412 2.24034 15.4978 3.13081 17.1198 4.74678C18.7417 6.36274 19.6342 8.51092 19.6336 10.7956C19.6315 15.5098 15.778 19.3455 11.0433 19.3455Z"
                fill="white"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_7299_834"
                x1="11"
                y1="20.9017"
                x2="11"
                y2="0.861438"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#20B038" />
                <stop offset="1" stop-color="#60D66A" />
            </linearGradient>
            <clipPath id="clip0_7299_834">
                <rect
                    width="21"
                    height="21"
                    fill="white"
                    transform="translate(0.5 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
